import ResponsiveContainer from '../../common/ResponsiveContainer';

const BankInfo = ({ children }) => (
  <div className='bg-gray-50 border border-gray-200 rounded-lg p-4 mt-2 font-semibold text-gray-800 leading-relaxed text-sm'>
    {children}
  </div>
);

const Donaciones = () => {
  return (
    <ResponsiveContainer className='font-montserrat mt-6 md:px-5'>
      <div className='bg-white rounded-xl shadow p-6 md:p-10'>

        <h1 className='font-bold text-2xl md:text-3xl text-darkred uppercase tracking-wide'>
          Información de Donaciones
        </h1>
        <hr className='border-gray-300 mt-3 mb-6' />

        <p className='text-gray-700 leading-relaxed mb-4'>
          Si quieres apoyar a Turkish4Love puedes donar desde{' '}
          <strong>5 Dólares o 5 Euros</strong> mensuales a través de PayPal.
        </p>

        <p className='text-gray-700 leading-relaxed mb-10'>
          Una vez que hayas donado envía un mail con el comprobante a{' '}
          <strong>mpaz331@gmail.com</strong>
        </p>

        <h2 className='font-bold text-xl md:text-2xl text-darkred uppercase tracking-wide mt-8'>
          Como Donar
        </h2>
        <hr className='border-gray-300 mt-3 mb-6' />

        <h3 className='font-bold text-base text-darkred uppercase tracking-wide mb-2'>
          PayPal
        </h3>
        <p className='text-gray-700 leading-relaxed mb-4'>
          Puedes donar a través de PayPal con el siguiente botón:
        </p>

        {/* PayPal donate card */}
        <a
          href='https://www.paypal.com/paypalme/Turkish4Love1?locale.x=es_XC'
          target='_blank'
          rel='noopener noreferrer'
          className='inline-flex items-center gap-3 bg-[#0070ba] hover:bg-[#005ea6] transition-colors text-white font-semibold px-6 py-4 rounded-xl shadow-md mb-6 group'
        >
          <svg className='w-8 h-8 shrink-0' viewBox='0 0 24 24' fill='currentColor'>
            <path d='M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.99l-.316 2.005a.4.4 0 0 0 .395.46H8.17l.853-5.385h1.97c4.396 0 7.248-2.176 8.132-6.47.33-1.628.148-2.963-.903-3.53z'/>
          </svg>
          <div className='flex flex-col leading-tight'>
            <span className='text-xs font-normal opacity-80'>Donar con</span>
            <span className='text-lg tracking-wide'>PayPal</span>
          </div>
        </a>

        <p className='text-gray-700 leading-relaxed mb-8'>
          Una vez que hayas donado{' '}
          <strong>envía un mail</strong> con el comprobante a{' '}
          <strong>mpaz331@gmail.com</strong>
        </p>

        <h3 className='font-bold text-base text-darkred uppercase tracking-wide mb-4'>
          Transferencia Bancaria
        </h3>

        <p className='text-gray-700 leading-relaxed'>
          Si vives en <strong>Argentina</strong> y prefieres donar a través de una cuenta bancaria
          puedes hacerlo a la cuenta de Chabe. Sus datos son:
        </p>
        <BankInfo>
          Isabel Norberta Giannoni<br />
          Número de Cuenta: 5029-503674/7<br />
          CUIL/CUIT: 27-21763208-6<br />
          CBU: 0140082303502950367479<br />
          Banco Provincia de Buenos Aires
        </BankInfo>

        <p className='text-gray-700 leading-relaxed mt-6'>
          Si vives en <strong>Chile</strong> y prefieres donar a través de una cuenta bancaria
          puedes hacerlo a la cuenta de María Paz. Sus datos son:
        </p>
        <BankInfo>
          María Paz Larrea<br />
          Cuenta Corriente Banco Santander<br />
          No: 65510731<br />
          Rut: 10.622.675-K<br />
          Mail: mpaz331@gmail.com
        </BankInfo>

        <p className='font-pacifico text-3xl text-gray-700 mt-12'>Turkish4Love</p>
      </div>
    </ResponsiveContainer>
  );
};

export default Donaciones;
